//Images Folder Access Globally
export const LOGO1 = require("../images/logo.png");
export const LOADING = "../assets/images/icons/loading.gif";

//Public Images Icons Folder Access Globally
export const ACCEPTED = "../assets/images/Icons/ic_accepted.svg";
export const ACTIVITY_HISTORY = "../assets/images/Icons/ic_activity-history.svg";
export const ADD = "../assets/images/Icons/ic_add.svg";
export const CALENDAR = "../assets/images/Icons/ic_calendar.svg";
export const CHECKMARK = "../assets/images/Icons/ic_check_mark.svg";
export const CLICK_PHOTO = "../assets/images/Icons/ic_click_photo.svg";
export const CLOSE = "../assets/images/Icons/ic_close.svg";
export const DOWN_ARROW = "../assets/images/Icons/ic_down-arrow.svg";
export const ERROR = "../assets/images/Icons/ic_error.svg";
export const EYE_CLOSE = "../assets/images/Icons/ic_eye-hide.svg";
export const EYE = "../assets/images/Icons/ic_eye.svg";
export const GO_BUTTON = "../assets/images/Icons/ic_go-button.svg";
export const INFO_BLACK = "../assets/images/Icons/ic_info-black.svg";
export const INFO = "../assets/images/Icons/ic_info.svg";
export const MENU_CALENDAR = "../assets/images/Icons/ic_menu-calendar.svg";
export const MENU_DASHBOARD = "../assets/images/Icons/ic_menu-dashboard.svg";
export const MENU_KRISHAK = "../assets/images/Icons/ic_menu-krishak.svg";
export const MENU_MORE = "../assets/images/Icons/ic_menu-more.svg";
export const MENU_TODAY = "../assets/images/Icons/ic_menu-today.svg";
export const MORE = "../assets/images/Icons/ic_more.svg";
export const NOTIFICATION = "../assets/images/Icons/ic_notification.svg";
export const REJECTED = "../assets/images/Icons/ic_rejected.svg";
export const KRISHAK_BRAND_LOYALTY_DESELECT = "../assets/images/Icons/krishak_brand_loyalty_deselect_icon.svg";
export const KRISHAK_BRAND_LOYALTY = "../assets/images/Icons/krishak_brand_loyalty_icon.svg";
export const KRISHAK_CROPPING_DESELECT = "../assets/images/Icons/krishak_cropping_deselect_icon.svg";
export const KRISHAK_CROPPING = "../assets/images/Icons/krishak_cropping_icon.svg";
export const KRISHAK_GENERAL_DESELECT = "../assets/images/Icons/krishak_general_deselect_icon.svg";
export const KRISHAK_GENERAL = "../assets/images/Icons/krishak_general_icon.svg";
export const KRISHAK_LAST_STEP_DESELECT = "../assets/images/Icons/krishak_last_step_deselect.svg";
export const KRISHAK_LAST_STEP = "../assets/images/Icons/krishak_last_step.svg";
export const KRISHAK_PRERAK_DESELECT = "../assets/images/Icons/krishak_prerak_deselect_icon.svg";
export const KRISHAK_PRERAK = "../assets/images/Icons/krishak_prerak_icon.svg";
export const TICK = "../assets/images/Icons/tick.svg";

//ASSETS->IMAGES FOLDER
export const LOGO = "../assets/images/logo.png";
export const LOGIN_SIDE_IMAGE = "../assets/images/login-side-image.jpg";
export const KRISHAK_INFO_IMG1 = "../assets/images/krishak-info-img1.png";
export const KRISHAK_INFO_IMG2 = "../assets/images/krishak-info-img2.png";


//New Images (10/08/2021)
export const OTP_VALIDATION_RIGHT = "../assets/images/Right.png";
export const OTP_VALIDATION_WRONG = "../assets/images/Wrong.png";



